import React from "react";
import {
  CAvatar,
  CBadge,
  CDropdown,
  CDropdownDivider,
  CDropdownHeader,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CModal,
  CModalHeader,
  CModalBody,
  CModalTitle,
  CModalFooter,
  CRow,
  CCol,
  CFormInput,
  CButton,
  CForm,
} from "@coreui/react";
import {
  cilBell,
  cilCreditCard,
  cilCommentSquare,
  cilEnvelopeOpen,
  cilFile,
  cilLockLocked,
  cilSettings,
  cilTask,
  cilUser,
} from "@coreui/icons";
import CIcon from "@coreui/icons-react";
import { useNavigate } from "react-router-dom";
import pic from "./../../components/images/profile.jpg";
import { useState } from "react";
import axios from "axios";
import Appconfig from "../../APPconfig";
import { ToastContainer, toast, Icons } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const AppHeaderDropdown = () => {
  var compid = localStorage.getItem("compid");
  function GetImage() {
    try {
      if (
        localStorage.getItem("USRImage") == "" ||
        localStorage.getItem("USRImage") == null
      ) {
        document.getElementById("Img").src = pic;
      } else {
        document.getElementById("Img").src = localStorage.getItem("USRImage");
      }
    } catch (message) {}
  }
  setTimeout(GetImage, 2000);

  const [visible, setVisible] = useState(false);
  const [CurPass, setCurPass] = useState("");
  const [NewPass, setNewPass] = useState("");
  const [ConPass, setConPass] = useState("");
  const [validatedPage1, setvalidatedPage1] = useState(false);
  let navigate = useNavigate();
  const routeChange = () => {
    let path = `/`;
    navigate(path);
  };
  async function Save() {
    setvalidatedPage1(true);
    //setloading(true);
    const form = document.getElementById("Page1form");
    if (form.checkValidity()) {
      await axios
        .post(
          Appconfig.URL + "/users/ChangePassword",
          {
            CurPass: CurPass,
            NewPass: NewPass,
            ConPass: ConPass,
            USREntry: localStorage.getItem("docentry"),
          },
          {
            headers: {
              compid: compid,
            },
          }
        )
        .then((response) => {        
          //alert(JSON.stringify(response.data));
          if (response.data[0].Statusflag == "Yes") {
            toast.success(response.data[0].Message, {
              position: toast.POSITION.TOP_RIGHT,
            });
            setvalidatedPage1(false);
          } else {
            toast.error(response.data[0].Message, {
              position: toast.POSITION.TOP_RIGHT,
            });
          }
        });
    }
  }
  const onClick = () => {
    routeChange(localStorage.removeItem("DocEntry"));
  };

  return (
    <CDropdown variant="nav-item">
      <CDropdownToggle placement="bottom-end" className="py-0" caret={false}>
        <img id="Img" size="md" className="avatar avatar-md" />
      </CDropdownToggle>
      <CDropdownMenu className="pt-0" placement="bottom-end">
        <CDropdownHeader className="bg-light fw-semibold py-2">
          Account
        </CDropdownHeader>
        {/* <CDropdownItem href="#">
          <CIcon icon={cilBell} className="me-2" />
          Updates
          <CBadge color="info" className="ms-2">
            42
          </CBadge>
        </CDropdownItem>
        <CDropdownItem href="#">
          <CIcon icon={cilEnvelopeOpen} className="me-2" />
          Messages
          <CBadge color="success" className="ms-2">
            42
          </CBadge>
        </CDropdownItem>
        <CDropdownItem href="#">
          <CIcon icon={cilTask} className="me-2" />
          Tasks
          <CBadge color="danger" className="ms-2">
            42
          </CBadge>
        </CDropdownItem>
        <CDropdownItem href="#">
          <CIcon icon={cilCommentSquare} className="me-2" />
          Comments
          <CBadge color="warning" className="ms-2">
            42
          </CBadge>
        </CDropdownItem>
        <CDropdownHeader className="bg-light fw-semibold py-2">Settings</CDropdownHeader>
        <CDropdownItem href="#">
          <CIcon icon={cilUser} className="me-2" />
          Profile
        </CDropdownItem>
        <CDropdownItem href="#">
          <CIcon icon={cilSettings} className="me-2" />
          Settings
        </CDropdownItem>
        <CDropdownItem href="#">
          <CIcon icon={cilCreditCard} className="me-2" />
          Payments
          <CBadge color="secondary" className="ms-2">
            42
          </CBadge>
        </CDropdownItem>
        <CDropdownItem href="#">
          <CIcon icon={cilFile} className="me-2" />
          Projects
          <CBadge color="primary" className="ms-2">
            42
          </CBadge>
        </CDropdownItem>
        <CDropdownDivider /> */}
        <CDropdownItem
          href="/"
          onClick={(e) => {
            e.preventDefault();
            setVisible(true);
          }}
        >
          <CIcon icon={cilLockLocked} className="me-2" />
          Change Password
        </CDropdownItem>
        <CDropdownDivider />
        <CDropdownItem
          href="/"
          onClick={() => {
            localStorage.removeItem("docentry");
            localStorage.removeItem("user");
            localStorage.removeItem("email");
            localStorage.removeItem("empid");
          }}
        >
          <CIcon icon={cilLockLocked} className="me-2" />
          Log Out
        </CDropdownItem>
      </CDropdownMenu>
      <CModal
        alignment="center"
        visible={visible}
        onClose={() => setVisible(false)}
        size="xl"
      >
        <CModalBody>
          <CForm
            className="row g-3 needs-validation"
            noValidate
            validated={validatedPage1}
            id="Page1form"
            // onSubmit={handleSubmit}
            // style={{ display: formvisiable == false ? "block" : "none" }}
          >
            <ToastContainer />
            <CRow>
              <CCol md={4}>
                <CFormInput
                  size="sm"
                  type="password"
                  feedbackInvalid="Please provide a Current Password"
                  id="txtCURPAS"
                  label="Current Password *"
                  required
                  value={CurPass}
                  onChange={(e) => {
                    setCurPass(e.target.value);
                  }}
                />
              </CCol>
              <CCol md={4}>
                <CFormInput
                  size="sm"
                  type="password"
                  feedbackInvalid="Please provide a New Password"
                  id="txtNEWPAS"
                  label="New Password *"
                  required
                  value={NewPass}
                  onChange={(e) => {
                    setNewPass(e.target.value);
                  }}
                />
              </CCol>
              <CCol md={4}>
                <CFormInput
                  size="sm"
                  type="password"
                  feedbackInvalid="Please provide a Confirm Password"
                  id="txtCONPASS"
                  label="Confirm Password *"
                  required
                  value={ConPass}
                  onChange={(e) => {
                    setConPass(e.target.value);
                  }}
                />
              </CCol>
            </CRow>
            <CRow className="mt-3">
              <CCol md={12}>
                <CButton
                  size="sm"
                  color="success"
                  id="btnChange"
                  type="button"
                  style={{
                    float: "left",
                    color: "success",
                    cursor: "pointer",
                  }}
                  onClick={(e, item) => {
                    e.preventDefault();
                    Save();
                  }}
                >
                  Change Password
                </CButton>
                <CButton
                  size="sm"
                  color="danger"
                  id="btnCancel"
                  type="button"
                  style={{
                    float: "left",
                    color: "success",
                    cursor: "pointer",
                    marginLeft: "8px",
                  }}
                  onClick={(e) => {
                    e.preventDefault();
                    setVisible(false);
                  }}
                >
                  Cancel
                </CButton>
              </CCol>
            </CRow>
          </CForm>
        </CModalBody>
      </CModal>
    </CDropdown>
  );
};

export default AppHeaderDropdown;
